<template>
  <div class="home" :class="{ 'collapsed': sidebarCollapsed }">
    <vita-side-nav v-if="!loader && (token && users)" />
    <div v-if="!loader">
      <div class="header" v-if="token && users">
        <vita-sub-header />
      </div>
      <div class="content" :style="'--users-count:' + users.length">
        <vita-beru-layout/>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import VitaBeruLayout from '@/components/VitaBeruLayout.vue';
import VitaSideNav from '@/components/VitaSideNav.vue';
import VitaSubHeader from "@/components/VitaSubHeader.vue";
import router from "@/router";
import { NewUser, User } from "@/types";
import { isDevHost } from "@/utils/host";
import { isUserAuthenticated } from '@/utils/user';
import { useSavedMonth } from '@/composables/useSavedMonth';
import { computed } from "vue";
import { useStore } from "vuex";

const store = useStore();
const users = computed<NewUser[]>(() => {
  return store.getters["data/pharmUsers"];
});

const userData = computed<User>(() => {
  return store.getters["user/userData"];
});


const sidebarCollapsed = computed(() => {
  return store.getters['getSidebarState']
})

const loader = computed<boolean>(() => {
  return store.getters["user/loader"];
});

const { getSavedMonth } = useSavedMonth()

const getPharmacies = async () => {
  !loader.value ? store.commit("user/setLoader", true) : null;
  store.commit("data/clearTomorrowWorkTime");
  store.commit("setDate", new Date());
  getSavedMonth()
  !userData.value ? await store.dispatch("user/userInfo") : null; // (OMR-7289)
  await store.dispatch("data/getPharmacies");
  await store.dispatch("data/getFondWorkTime");
  await store.dispatch("data/getHolidays");
  await store.dispatch("data/getFondWorkTimeHuman");
  store.commit("user/setLoader", false);
};

const token = localStorage.getItem("token");

const isBeruAccessRole = computed<boolean>(() => {
  return store.getters['getBeruAccessRole']
})

if (isUserAuthenticated()) {
  getPharmacies().then(() => {
    if (!isBeruAccessRole.value) {
      router.push("/");
    }
  });
} else {
  isDevHost() ? router.push({ name: "authentication-test" }) : router.push({ name: "authentication" })
}
</script>

<style lang="scss" scoped>
@use "../static/style/variables.scss" as *;
@use "../static/style/mixins.scss" as *;

.home {
  --sidebar-gap: 118px;
  display: flex;
  justify-content: space-between;
  min-height: 100vh;

  > div:last-child {
    flex: 1;
    display: flex;
    flex-direction: column;
    max-width: calc(100vw - var(--sidebar-gap));
  }
}
</style>